import React from "react";
import BaseMicroRich from "@v4/gatsby-theme-talend/src/components/MicroRich/MicroRich";
import CTA from "../cta/Cta";

const MicroRich = (props) => <BaseMicroRich CTA={CTA} {...props} />;

export default MicroRich;
